
export class CssElement {
    private _element: HTMLElement = null;
    public static wrap(element: HTMLElement):CssElement {
        return new CssElement(element);
    }
    public constructor(element: HTMLElement) {
        this._element = element;
    }
    public show(){
        this._element.style.display="inline"
    }
    public hide(){
        this._element.style.display="none"
    }
    public get hidden():boolean{
        return this._element.style.display.toLowerCase()=="none";
    }
    public set visibility(set_visibile: boolean) {

        if (set_visibile) {
            this._element.style.visibility = "visible"
            this.show()
        }
        else {
            this._element.style.visibility = "hidden";
            this.hide()
        }
    }
    public get visibility(): boolean {
        return this._element.style.visibility != "hidden"
    }
}


// WEBPACK FOOTER //
// ./src/ts/css_utils.ts